import React from 'react';

import { FlexColumn } from '@editor/components/utilities/layouts';
import { Spacer } from '@repo/ui/components/Spacer';
import { P3 } from '@repo/ui/components/Typography';
import { pluralSuffix } from '@repo/ui/utils';
import times from 'lodash/times';

import {
  planSelectionStoreSelector,
  usePlanSelectionStore,
} from '../../../stores/planSelectionStore';
import { useUserStore, userStoreSelector } from '../../../stores/userStore';
import Select from '../../SelectNew/Select';

const memberOptions = times(50, (index) => {
  const members = index + 1;
  return {
    id: members,
    label: `${members} Member${pluralSuffix(members)}`,
  };
});

const PlanMembersSelector: React.FC = () => {
  const isTeam = useUserStore(userStoreSelector.isTeam);
  const quantity = usePlanSelectionStore(planSelectionStoreSelector.quantity);
  const disabled = usePlanSelectionStore(planSelectionStoreSelector.disabled);
  const { setMembersQuantity } = usePlanSelectionStore(
    planSelectionStoreSelector.actions
  );

  if (!isTeam) {
    return null;
  }

  return (
    <FlexColumn gap="6px" width="100%">
      <Spacer height="18px" />
      <P3>Seats</P3>
      <Select
        activeOption={
          memberOptions.find(({ id }) => id === quantity) ?? memberOptions[0]
        }
        customStyles={{ width: '100%' }}
        disabled={disabled}
        options={memberOptions}
        onSelect={({ id }): void => {
          setMembersQuantity(id);
        }}
      />
    </FlexColumn>
  );
};

export default PlanMembersSelector;
